module.exports = __webpack_public_path__ + "static/img/user.ae3e9bf1.png";